"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureBrowserWebApp = exports.reportBroswerHandledError = void 0;
const BrowserSentry = __importStar(require("@sentry/react"));
const tracing_1 = require("@sentry/tracing");
const reportBroswerHandledError = (err, tags) => {
    const sentryContext = tags ? { tags: { ...tags } } : undefined;
    BrowserSentry.captureException(err, sentryContext);
};
exports.reportBroswerHandledError = reportBroswerHandledError;
const configureBrowserWebApp = ({ sentry, }) => {
    if (sentry.SENTRY_ENVIRONMENT && sentry.SENTRY_DSN) {
        try {
            BrowserSentry.init({
                dsn: sentry.SENTRY_DSN,
                integrations: [new tracing_1.Integrations.BrowserTracing()],
                tracesSampleRate: parseFloat(sentry.SENTRY_SAMPLE_RATE || '1.0'),
                environment: sentry.SENTRY_ENVIRONMENT,
                release: sentry.SENTRY_RELEASE,
                initialScope: {
                    // This tag allows identifying which errors are from server vs client
                    tags: { 'sent-from': 'react' },
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
};
exports.configureBrowserWebApp = configureBrowserWebApp;
